import { lowerFirst, upperFirst } from 'lodash';
import { FIELD_WIDTH } from '../format/fieldWidth';
import { quote } from './words';
import { USER_PLACEHOLDERS } from './userPlaceholders';

const CANT_MOVE = "Can't move it there:";

const dependsOn = (from: string, to: string): string => `${from} depends on ${to}`;

const stillInEffect = (value: string | undefined): string => {
  return value === undefined ? '' : ` Still in effect: ${value}`;
};

export const AUTHOR_TEXTS = {
  fieldWidth: {
    label: 'Field width',
    options: {
      [FIELD_WIDTH.THIRD]: '1/3',
      [FIELD_WIDTH.HALF]: '1/2',
      [FIELD_WIDTH.TWO_THIRDS]: '2/3',
      [FIELD_WIDTH.FULL]: 'Full',
    },
  },
  defaultValue: {
    unfinished: 'Unfinished, not saved.',
    noDefault: (field: string) => `${upperFirst(field)} has no default value.`,
    cantHold: (field: string) => `That isn't a value ${field} can hold.`,
  },
  range: {
    unfinished: (inEffect?: string) => `Unfinished, not saved. ${stillInEffect(inEffect)}`,
    wrongOrder: (end: 'min' | 'max', other: string, dates: boolean, inEffect?: string) => {
      const than = quote(other);
      const mistake = dates
        ? `${end === 'min' ? 'Later' : 'Earlier'} than ${than}`
        : `${end === 'min' ? 'More' : 'Less'} than ${than}`;
      return `${mistake}, so not saved.${stillInEffect(inEffect)}`;
    },
  },
  pattern: {
    checkedAgainstWhole: 'Checked against the whole value',
    invalid: (inEffect?: string) => `Not a valid regular expression, so not saved.${stillInEffect(inEffect)}`,
    unfinished: (inEffect?: string) => `Unfinished, not saved. ${stillInEffect(inEffect)}`,
    matches: 'Matches',
    doesntMatch: "Doesn't match",
    addErrorText: `Add an error text below: otherwise user sees ${quote(USER_PLACEHOLDERS.pattern.invalid)}.`,
  },
  arranging: {
    stayBelow: (from: string, to: string) => `${CANT_MOVE} ${dependsOn(from, to)}, so it has to stay below it.`,
    notInside: (from: string, to: string) => `${CANT_MOVE} ${dependsOn(from, to)}, which can't be inside it.`,
    notInsideContainer: (from: string, to: string) => `${CANT_MOVE} ${dependsOn(from, to)}, it can't be inside it.`,
    notIntoGroup: (from: string, to: string) =>
      `${CANT_MOVE} ${dependsOn(from, to)}, and a field inside a repeatable group can be used only inside its group.`,
    uniqueOutsideGroup: (field: string) =>
      `${CANT_MOVE} ${field} has “No repeats across rows”, which works only in a repeatable group.`,
    other: (reason: string) => `${CANT_MOVE} ${lowerFirst(reason)}`,
  },
  settingsPanels: {
    stepNotSaved: 'The step is a number above 0',
  },
};
